export const lc = (s = "") => s.trim().toLowerCase();

export const tokens = (s = "") =>
  lc(s)
    .replace(/[/#.,&()\-_|>]+/g, " ")
    .split(/\s+/)
    .filter(Boolean);

export const uniq = <T,>(a: T[]): T[] => {
  const seen = new Set<T>();
  const out: T[] = [];
  for (const val of a) {
    if (!seen.has(val)) {
      seen.add(val);
      out.push(val);
    }
  }
  return out;
};

export const makeNodeId = (pathKeys: string[]) => pathKeys.map(lc).join(":");

export const makeItemId = (pageId: string, itemKey: string) =>
  `${pageId}:${lc(itemKey)}`;
